import { GO_TO_UHI_LOGIN } from '../routes/paths';
import { track } from '../tracking';
import {
    VERIFY_MOBILE_NUMBER,
    VERIFY_OTP,
    RESEND_OTP,
    LOGOUT,
    DOC_TOOL,
    INIT_LOGIN,
    VERIFY_LOGIN,
} from './constants';

export interface OtpResponse {
    success: boolean;
    message: string;
    triggered: boolean;
    length?: number;
    retries?: number;
    nextOtpRequest: Date | string;
}

export interface InitLoginResponse {
    txn_id?: string;
    message?: string;
    method?: number;
    error?: {
        code?: string;
        message?: string;
    };
}

interface InitUhiResponse {
    success: boolean;
    data: {
        authUrl: string;
    };
}

const headers = {
    'Content-Type': 'application/json',
    'Client-id': 'doc-web',
};

const authFetch = (url: string, body?: string) =>
    fetch(url, {
        method: 'POST',
        headers: headers,
        body,
        mode: 'cors',
        credentials: 'include',
    })
        .then((res) => {
            if (res.status === 200) {
                return res.json();
            } else {
                track('ERROR', { on: url, error: res.status.toString() });
                throw new Error('doc profile not found');
            }
        })
        .catch((e) => {
            track('ERROR', { on: url, error: e.message });
            throw e;
        });

export const initLogin = (
    identifier: string,
    type: 'mobile' | 'email',
): Promise<InitLoginResponse> =>
    authFetch(
        INIT_LOGIN('v2'),
        JSON.stringify({
            identifier: identifier,
            idp: type === 'mobile' ? 'mob' : 'email',
        }),
    );

export interface VerifyOtpResponse {
    error?: string;
    code?: number;

    txn_id: string;
    skip_state: number;
    method: number;
    data: {
        tokens: {
            sess: string;
            refresh: string;
        };
        profile?: {
            at: string;
            dob: string;
            'dob-valid': string;
            email: string;
            fn: string;
            gen: string;
            'is-d': boolean;
            'is-p': boolean;
            ln: string;
            mobile: string;
            oid: string;
            uuid: string;
        };
    };
}

export interface VerifyUhiResponse {
    success: boolean;
    data?: {
        sess: string;
        profile?: {
            at: string;
            dob: string;
            'dob-valid': string;
            email: string;
            fn: string;
            gen: string;
            'is-d': boolean;
            'is-p': boolean;
            ln: string;
            mobile: string;
            oid: string;
            uuid: string;
        };
    };
}

export const verifyOtp = (code: string, txn_id: string): Promise<VerifyOtpResponse> =>
    authFetch(
        `${VERIFY_LOGIN('v2')}`,
        JSON.stringify({
            code,
            txn_id,
        }),
    );

export const resendOtp = (txn_id: string): Promise<InitLoginResponse> =>
    authFetch(
        RESEND_OTP('v2'),
        JSON.stringify({
            txn_id,
        }),
    );

export const initUhi = (): Promise<InitUhiResponse> =>
    authFetch(
        VERIFY_MOBILE_NUMBER,
        JSON.stringify({
            type: 'uhi',
            flow: 'appointment',
            payload: {
                module: 'DCM',
                redirect_uri: `${DOC_TOOL}${GO_TO_UHI_LOGIN}`,
            },
        }),
    );

export const verifyUhi = (state: string, code: string): Promise<VerifyUhiResponse> =>
    authFetch(
        VERIFY_OTP,
        JSON.stringify({
            type: 'uhi',
            flow: 'appointment',
            payload: {
                state,
                code,
            },
        }),
    );

export const logout = (): Promise<void> => authFetch(LOGOUT);
